export const scrollShadow = {
    mounted(el, binding) {
      // Extract options from binding
      const options = binding.value || {};
      const threshold = options.threshold || 0;
      
      // Determine direction(s) to monitor - default to vertical if not specified
      const directions = options.directions || ['vertical'];
      const horizontal = directions.includes('horizontal');
      const vertical = directions.includes('vertical') || (!horizontal);
      
      const applyScrollClasses = () => {
        // Track which sides have hidden content
        const shadows = {
          top: false,
          right: false,
          bottom: false,
          left: false
        };
        
        // Check vertical scrolling
        if (vertical) {
          shadows.top = el.scrollTop > threshold;
          shadows.bottom = el.scrollTop + el.clientHeight < el.scrollHeight - threshold;
        }
        
        // Check horizontal scrolling
        if (horizontal) {
          shadows.left = el.scrollLeft > threshold;
          shadows.right = el.scrollLeft + el.clientWidth < el.scrollWidth - threshold;
        }
        
        // Remove all shadow classes first
        el.classList.remove(
          'scroll-shadow-top', 
          'scroll-shadow-bottom', 
          'scroll-shadow-left', 
          'scroll-shadow-right',
          'scroll-shadow-vertical-both',
          'scroll-shadow-horizontal-both',
          'scroll-shadow-all'
        );
        
        // Apply the appropriate classes
        if (vertical) {
          if (shadows.top && shadows.bottom) {
            el.classList.add('scroll-shadow-vertical-both');
          } else if (shadows.top) {
            el.classList.add('scroll-shadow-top');
          } else if (shadows.bottom) {
            el.classList.add('scroll-shadow-bottom');
          }
        }
        
        if (horizontal) {
          if (shadows.left && shadows.right) {
            el.classList.add('scroll-shadow-horizontal-both');
          } else if (shadows.left) {
            el.classList.add('scroll-shadow-left');
          } else if (shadows.right) {
            el.classList.add('scroll-shadow-right');
          }
        }
        
        // Add all-around shadow class if content is hidden in all directions
        if (shadows.top && shadows.bottom && shadows.left && shadows.right) {
          el.classList.add('scroll-shadow-all');
        }
      };
  
      // Apply initially and add event listeners
      applyScrollClasses();
      el.addEventListener('scroll', applyScrollClasses);
      
      // Store the handler for cleanup
      el._scrollShadowHandler = applyScrollClasses;
      
      // Handle window resize events
      window.addEventListener('resize', applyScrollClasses);
      el._scrollShadowResizeHandler = applyScrollClasses;
      
      // Handle content changes with MutationObserver
      const observer = new MutationObserver(applyScrollClasses);
      observer.observe(el, { 
        childList: true,
        subtree: true,
        characterData: true
      });
      el._scrollShadowObserver = observer;
    },
    
    unmounted(el) {
      // Clean up event listeners
      if (el._scrollShadowHandler) {
        el.removeEventListener('scroll', el._scrollShadowHandler);
      }
      if (el._scrollShadowResizeHandler) {
        window.removeEventListener('resize', el._scrollShadowResizeHandler);
      }
      if (el._scrollShadowObserver) {
        el._scrollShadowObserver.disconnect();
      }
    }
};